import { useDefaultAttachmentsApiForControllerRoute } from "."

export function useChatPostAttachmentApi() {
  const defaultAPI = useDefaultAttachmentsApiForControllerRoute("chatpost")

  return {
    ...defaultAPI,
  }
}
